/* global window URL MessageEvent */

import { Button } from "@fluentui/react-components";
import React, { FC, useCallback, useEffect } from "react";
import * as config from "../../../config";
import useStyles from "./styles.login";
import authStorage from "../../../services/storage/auth.storage";

type LoginProps = {
  authenticator: () => void;
};

const Login: FC<LoginProps> = ({ authenticator }) => {
  const styles = useStyles();

  const handleMessage = useCallback(
    (event: MessageEvent) => {
      // Verify the origin of the message
      const noResponse = !event.data || !event.data.authResponse;
      if (event.origin !== config.FRONTEND_URL || noResponse) return;

      // Check if we received the auth token
      authStorage.token = event.data.authResponse;
      authenticator();
    },
    [authenticator]
  );

  useEffect(() => {
    // Add message listener
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [handleMessage]);

  const handleLogin = useCallback(() => {
    const origin = window.location.origin;
    const loginUrl = new URL(`${config.FRONTEND_URL}/en/dashboard`);
    loginUrl.searchParams.append("is_office_addin_enabled", "true");
    loginUrl.searchParams.append("addin_origin", origin);

    window.open(loginUrl, "_blank", "noopener=false");
  }, []);

  return (
    <div className={styles.container}>
      <Button appearance="primary" onClick={handleLogin}>
        Login
      </Button>
    </div>
  );
};

export default Login;
